import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (preset) => {
    return (_openBlock(), _createBlock(_component_v_btn, {
      key: preset.label,
      class: "ma-1",
      color: _ctx.activePreset === preset.label ? 'primary' : '',
      variant: "tonal",
      size: "small",
      onClick: ($event: any) => (_ctx.onSelect(preset))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(preset.label), 1)
      ]),
      _: 2
    }, 1032, ["color", "onClick"]))
  }), 128))
}